import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newUnitButton: {
    id: 'course-authoring.course-outline.subsection.button.new-unit',
    defaultMessage: 'Add Lesson',
  },
  editUnitButton: {
    id: 'course-authoring.course-outline.subsection.button.edit-unit',
    defaultMessage: 'Edit Lesson',
  },
  pasteButton: {
    id: 'course-authoring.course-outline.subsection.button.paste-unit',
    defaultMessage: 'Paste unit',
  },
});

export default messages;
